import { TranslationObject } from '../i18n/translation';

const translations: TranslationObject = {
  title: { id: 'settings.title', nb: 'Mine innstillinger', en: 'My settings' },
  subtitle: {
    id: 'settings.subtitle',
    nb: 'Her finner du dine profildata og innstillinger for Arbeidslivsportalen',
    en: 'An overview of your account and settings',
  },
  userTitle: {
    id: 'settings.user.title',
    nb: 'Personopplysninger',
    en: 'Account details',
  },
  userSubtitle: {
    id: 'settings.user.subtitle',
    nb: 'Dine personlige detaljer hentes fra innloggingsmetoden du bruker for å logge deg på Arbeidslivsportalen. Disse kan ikke endres.',
    en: 'Your account details are retrieved from the identity provider you use to sign in to Arbeidslivsportalen. These cannot be edited.',
  },
  userphone: {
    id: 'settings.user.phone',
    nb: 'Telefon',
    en: 'Phone',
  },
  userMail: {
    id: 'settings.user.mail',
    nb: 'Epost',
    en: 'Mail',
  },
  userName: { id: 'settings.user.name', nb: 'Navn', en: 'Name' },
  useremail: { id: 'settings.user.email', nb: 'E-post', en: 'E-mail' },
  portalTitle: {
    id: 'settings.portal.title',
    nb: 'Portalinnstillinger',
    en: 'Portal settings',
  },
  portalSubtitle: {
    id: 'settings.portal.subtitle',
    nb: 'Her kan du endre innstillinger for portalen.',
    en: 'Change portal settings',
  },
  languageHeader: {
    id: 'settings.language.header',
    nb: 'Velg språk',
    en: 'Select language',
  },
  languageOptionBokmal: {
    id: 'settings.language.option.nb',
    nb: 'Norsk (bokmål)',
    en: 'Norsk (bokmål)',
  },
  languageOptionEnglish: {
    id: 'settings.language.option.en',
    nb: 'English',
    en: 'English',
  },
  deleteTitle: {
    id: 'settings.delete.title',
    nb: 'Slett brukerkonto',
    en: 'Delete user account',
  },
  deleteSubtitle: {
    id: 'settings.delete.subtitle',
    nb: 'Sletter din brukerkonto og alle dine personopplysninger fra Arbeidslivsportalen.',
    en: 'Delete your user account and all personal information from Arbeidslivsportalen.',
  },
  deleteButton: {
    id: 'settings.delete.button',
    nb: 'Jeg vil slette brukerkontoen min',
    en: 'I want to delete my user account',
  },
  deleteConfirmationTitle: {
    id: 'settings.delete.confirmationTitle',
    nb: 'Sletting av konto',
    en: 'Account deletion',
  },
  deleteConfirmationMessage: {
    id: 'settings.delete.confirmationMessage',
    nb: 'Er du sikker på at du vil slette kontoen din? Alle dine persondata vil slettes, du vil fjernes fra alle fremtidige praksisaktiviteter og logges ut, og det er ikke mulig å angre denne handlingen!',
    en: "Are you sure you want to delete your account? All your personal data will be deleted, you will be removed from future activities and be logged out, and it isn't possible to undo this action!",
  },
};

export default translations;
